class CharmsSelection extends HTMLElement {
    constructor() {
        super();

        if(localStorage.getItem("selected_charms")) {
            this.selection = JSON.parse(localStorage.getItem("selected_charms"));
            this.render();
            document.querySelector('.step-2').removeAttribute('disabled');
        } else {
            this.selection = [];
        }

        console.log(this.querySelector('template').innerHTML);
        this.pinVariants = JSON.parse(decodeURIComponent(this.querySelector('template').innerHTML));

        this.querySelector('#confirm-selection').addEventListener('click', () => {
            this.addToCart();
        })

        this.querySelector('.mobile-close').addEventListener('click', () => {
            this.classList.add('contracted');
        });
        this.querySelector('.desktop-close').addEventListener('click', () => {
            this.classList.add('minimised');
        });
        this.querySelector('.mobile-open').addEventListener('click', () => {
            this.classList.remove('contracted');
        });

        this.style.display = 'block';
    }

    recordPinSelection(id) {
        const item = this.pinVariants.find(variant => variant.id === id);
        item.type = 'pin';
        item.title = item.title.replaceAll('+', ' ');
        this.selection = this.selection.filter(item => item.type !== 'pin');
        this.selection.push(item);
        localStorage.setItem("selected_charms", JSON.stringify(this.selection));
        this.render();
        document.querySelector('.step-2').removeAttribute('disabled');
    }

    addToSelection(encoded_product, encoded_variant) {
        const variant = JSON.parse(decodeURIComponent(encoded_variant));
        const product = JSON.parse(decodeURIComponent(encoded_product));

        if(this.selection.find(item => item.id === variant.id)) {
            this.selection.find(item => item.id === variant.id).quantity++;
            this.selection.find(item => item.id === variant.id).price += variant.price;
        } else {
            const item = {
                id: variant.id,
                title: product.title.replaceAll('+', ' '),
                image: product.featured_image,
                type: 'charm',
                variant: variant.title,
                price: variant.price,
                hasVariants: product.variants.length > 1,
                quantity: 1
            }; 
            this.selection.push(item);
        }
        localStorage.setItem("selected_charms", JSON.stringify(this.selection));
        this.render();
        const objDiv = this.querySelector('charms-selection ul');
        objDiv.scrollTop = objDiv.scrollHeight + 20;
    }

    removeItem(item_id) {
        const item = this.selection.find(i => i.id == item_id);
        if(item.type == 'pin' && this.selection.length > 1) {
            alert('You must have at least one pin in your selection');
            return;
        }
        this.selection = this.selection.filter(i => i.id !== item_id);
        localStorage.setItem("selected_charms", JSON.stringify(this.selection));
        this.render();
        if(this.selection.length === 0) {
            document.querySelector('.step-2').setAttribute('disabled', '');
            document.querySelectorAll('.pin-option').forEach(option => option.classList.remove('selected'));
        }
    }

    addToCart() {

        document.getElementById('confirm-selection').innerHTML = 'Adding to cart...';

        let body = [];
        body = {
            items: []
        }

        this.selection.forEach(item => {
            body.items.push({
                 id: item.id,
                 quantity: item.quantity
            })
        });

        body = JSON.stringify(body);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body
        })
        .then(response => {
            return response.json();
        })
        .then(json_response => {
            console.log(json_response);
            if(json_response.status != 'bad_request') {
                this.selection = [];
                localStorage.setItem("selected_charms", JSON.stringify(this.selection));
                this.render();
                document.getElementById('confirm-selection').innerHTML = 'Added to cart';
                setTimeout(() => {
                    document.getElementById('confirm-selection').innerHTML = 'Confirm selection';
                }, 1000);
                window.SLIDECART_UPDATE(function() {
                    window.SLIDECART_OPEN();
                })
            } else {
                alert('Error: '+json_response.message);
            }
        })
        .catch((error) => {
            alert('Error: '+error);
            console.error('Error:', error);
        });
    }

    render() {
        this.querySelector('ul').innerHTML = '';
        if(this.selection.length === 0) {
            this.classList.add('empty');
            document.body.scrollTop = document.documentElement.scrollTop = 250;
            return;
        }
        this.selection.forEach(item => {
            if(item.type === 'pin') {
                this.querySelector('ul').innerHTML += `<li>
                    <img src="${item.featured_image.src+'&width=322'}" alt="${item.title}" width="322">
                    <div>
                        <h3>${item.title}</h3>
                        <div>Qty <span id="qty">1</span></div>
                        <div class="remove" onclick="document.querySelector('charms-selection').removeItem(${item.id})"><span class='desktop'>Remove</span><span class='mobile'><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L1.99999 6.00001" stroke="white" stroke-width="0.5" stroke-linecap="round"/><path d="M6 6L1.99999 1.99999" stroke="white" stroke-width="0.5" stroke-linecap="round"/></svg></span></div>
                    </div>
                </li>`;
            }
            if(item.type === 'charm') {
                this.querySelector('ul').innerHTML += `<li>
                    <img src="${item.image+'&width=322'}" alt="${item.title}" width="322">
                    <div>
                        <h3>${item.title}</h3>
                        ${item.hasVariants ? `<div>Initial: ${item.variant}</div>` : ''}
                        <div>Qty <span id="qty">${item.quantity}</span></div>
                        <div class="remove" onclick="document.querySelector('charms-selection').removeItem(${item.id})"><span class='desktop'>Remove</span><span class='mobile'><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L1.99999 6.00001" stroke="white" stroke-width="0.5" stroke-linecap="round"/><path d="M6 6L1.99999 1.99999" stroke="white" stroke-width="0.5" stroke-linecap="round"/></svg></span></div>
                    </div>
                </li>`;
            }
            const sum = this.selection.map(item => item.price).reduce((accumulator, currentValue) => accumulator + currentValue, 0);

            this.querySelector('#selection-total').innerHTML = Shopify.formatMoney(sum);
        });
        this.classList.remove('empty');
        this.classList.remove('contracted');
        this.classList.remove('minimised');
    }
}

customElements.define('charms-selection', CharmsSelection);